import directiveAccordion from './accordion';
import directiveAdvancedSearch from './advancedSearch';
import directiveApplyFastResult from './applyFastResults';
import directiveDatePickerWrapper from './datePickerWrapper';
import directiveFastResult from './fastResult';
import directiveFastResultTrigger from './fastResultTrigger';
import directiveHyphenation from './hyphenation';
import directiveLinkTrigger from './linkTrigger';
import directiveMoveTopOnFocus from './moveTopOnFocus';
import maxEqualWidth from './maxEqualWidth';
import mediaelement from './mediaelement';
import directiveMeetingStaff from './meetingStaff';
import directiveRaceCourse from './raceCourse';
import directiveRaceReplay from './raceReplay';
import directiveVideoControls from './videoControls';
import directiveSelectDate from './selectDate';
import directiveTableToolbar from './tableToolbar';
import directiveSuccessBoxes from './successBoxes';
import directiveTicker from './ticker';
import verticalScroll from './verticalScroll';
import directiveErrorComment from './errorComment';
import directiveErrorLightBox from './errorLightBox';

const directives = angular.module('results.directives', [])
    .directive('directiveAccordion', directiveAccordion)
    .directive('directiveAdvancedSearch', directiveAdvancedSearch)
    .directive('directiveApplyFastResult', directiveApplyFastResult)
    .directive('directiveDatePickerWrapper', directiveDatePickerWrapper)
    .directive('directiveFastResult', directiveFastResult)
    .directive('directiveFastResultTrigger', directiveFastResultTrigger)
    .directive('directiveHyphenation', directiveHyphenation)
    .directive('directiveLinkTrigger', directiveLinkTrigger)
    .directive('directiveMoveTopOnFocus', directiveMoveTopOnFocus)
    .directive('maxEqualWidth', maxEqualWidth)
    .directive('mediaelement', mediaelement)
    .directive('directiveMeetingStaff', directiveMeetingStaff)
    .directive('directiveRaceCourse', directiveRaceCourse)
    .directive('directiveRaceReplay', directiveRaceReplay)
    .directive('directiveVideoControls', directiveVideoControls)
    .directive('directiveSelectDate', directiveSelectDate)
    .directive('directiveSuccessBoxes', directiveSuccessBoxes)
    .directive('directiveTicker', directiveTicker)
    .directive('verticalScroll', verticalScroll)
    .directive('directiveTableToolbar', directiveTableToolbar)
    .directive('directiveErrorComment', directiveErrorComment)
    .directive('directiveErrorLightBox', directiveErrorLightBox);

export default directives;



// WEBPACK FOOTER //
// ./src/js/directives/index.js